import { CachePolicy } from "contentstack";
import { ContentStack, ContentStackLivePreview } from "./business.client.js";
import { unstable_cache } from "next/cache";
const DEFAULT_FIELD_EXCEPTIONS = [
  "_in_progress",
  "_metadata",
  "ACL",
  "created_by",
  "created_at",
  "tags",
  "updated_by",
  "updated_at",
  "publish_details"
];
const _findOneBusinessEntryByContentType = async function findOneBusinessEntryByContentType2(contentType, locale, modifiers, fieldExceptions, enableLivePreview) {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    let result;
    let oldestEntry;
    if (modifiers.sortAscending === true && modifiers.field) {
      const sortedSearch = await stackClient.stack.ContentType(contentType).Query().language(locale).ascending(modifiers.field).except(fieldExceptions).toJSON().find();
      if ((sortedSearch == null ? void 0 : sortedSearch.length) > 0) {
        const entriesList = sortedSearch[0];
        if ((entriesList == null ? void 0 : entriesList.length) > 0) {
          oldestEntry = entriesList[0];
        }
      }
      result = oldestEntry;
    } else {
      result = await stackClient.stack.ContentType(contentType).Query().language(locale).except(fieldExceptions).toJSON().findOne();
    }
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully using findOneBusinessEntryByContentType with
                    contentType: ${contentType},
                    locale: ${locale},
                    fieldExceptions: ${fieldExceptions},
                    enableLivePreview: ${enableLivePreview}
                    resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack findOneBusinessEntryByContentType with
            contentType: ${contentType},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in err: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_findOneBusinessEntryByContentType = unstable_cache(
  _findOneBusinessEntryByContentType,
  ["digital_findOneBusinessEntryByContentType"],
  { revalidate: 1800 }
);
const findOneBusinessEntryByContentType = async function findOneBusinessEntryByContentType3(contentType, locale, modifiers, fieldExceptions = DEFAULT_FIELD_EXCEPTIONS, enableLivePreview = false) {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_findOneBusinessEntryByContentType : _findOneBusinessEntryByContentType;
  return fn(
    contentType,
    locale,
    modifiers,
    fieldExceptions,
    enableLivePreview
  );
};
const _findPaginateEntriesByContentType = async (contentType, query, locale, fieldExceptions, skip, limit) => {
  const stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  try {
    const result = await stackClient.stack.ContentType(contentType).Query().query(query).language(locale).except(fieldExceptions).skip(skip).limit(limit).toJSON().find();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully using findPaginateEntriesByContentType with
        contentType: ${contentType},
        locale: ${locale},
        fieldExceptions: ${fieldExceptions},
        skip: ${skip},
        limit: ${limit},
        resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack findPaginateEntriesByContentType with
        contentType: ${contentType},
        locale: ${locale},
        fieldExceptions: ${fieldExceptions},
        skip: ${skip},
        limit: ${limit},
        resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_findPaginateEntriesByContentType = unstable_cache(
  _findPaginateEntriesByContentType,
  ["digital_findPaginateEntriesByContentType"],
  { revalidate: 1800 }
);
const findPaginateEntriesByContentType = async function findPaginateEntriesByContentType2(contentType, query, locale, fieldExceptions, skip, limit) {
  const fn = typeof window === "undefined" ? cached_findPaginateEntriesByContentType : _findPaginateEntriesByContentType;
  return fn(contentType, query, locale, fieldExceptions, skip, limit);
};
const _findCountOfAllEntriesByContentType = async (contentType, query, locale, fieldExceptions, enableLivePreview) => {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    const result = await stackClient.stack.ContentType(contentType).Query().query(query).language(locale).except(fieldExceptions).count().toJSON().find();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully using findCountOfAllBusinessEntriesByContentType with
            contentType: ${contentType},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack findCountOfAllBusinessEntriesByContentType with
            contentType: ${contentType},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_findCountOfAllEntriesByContentType = unstable_cache(
  _findCountOfAllEntriesByContentType,
  ["digital_findCountOfAllEntriesByContentType"],
  { revalidate: 1800 }
);
const findCountOfAllEntriesByContentType = async function findCountOfAllEntriesByContentType2(contentType, query, locale, fieldExceptions, enableLivePreview) {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_findCountOfAllEntriesByContentType : _findCountOfAllEntriesByContentType;
  return fn(
    contentType,
    query,
    locale,
    fieldExceptions,
    enableLivePreview
  );
};
const _findAllBusinessEntriesByContentType = async function findAllBusinessEntriesByContentType2(contentType, query, locale, fieldExceptions, enableLivePreview) {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    const result = await stackClient.stack.ContentType(contentType).Query().query(query).language(locale).except(fieldExceptions).toJSON().find();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully using findAllBusinessEntriesByContentType with
            contentType: ${contentType},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack findAllBusinessEntriesByContentType with
            contentType: ${contentType},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_findAllBusinessEntriesByContentType = unstable_cache(
  _findAllBusinessEntriesByContentType,
  ["digital_findAllBusinessEntriesByContentType"],
  { revalidate: 1800 }
);
const findAllBusinessEntriesByContentType = async function findAllBusinessEntriesByContentType3(contentType, query, locale, fieldExceptions = DEFAULT_FIELD_EXCEPTIONS, enableLivePreview = false) {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_findAllBusinessEntriesByContentType : _findAllBusinessEntriesByContentType;
  return fn(
    contentType,
    query,
    locale,
    fieldExceptions,
    enableLivePreview
  );
};
const _findOneBusinessEntryWhere = async function _findOneBusinessEntryWhere2(contentType, key, value, locale, fieldExceptions, enableLivePreview) {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    const result = await stackClient.stack.ContentType(contentType).Query().where(key, value).language(locale).except(fieldExceptions).toJSON().findOne();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully using findOneBusinessEntryWhere with
            contentType: ${contentType},
            key: ${key},
            value: ${value},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack findOneBusinessEntryWhere with
            contentType: ${contentType},
            key: ${key},
            value: ${value},
            locale: ${locale},
            fieldExceptions: ${fieldExceptions},
            enableLivePreview: ${enableLivePreview}
            resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_findOneBusinessEntryWhere = unstable_cache(
  _findOneBusinessEntryWhere,
  ["digital_findOneBusinessEntryWhere"],
  {
    revalidate: 1800
  }
);
const findOneBusinessEntryWhere = async function findOneBusinessEntryWhere2(contentType, key, value, locale, fieldExceptions = DEFAULT_FIELD_EXCEPTIONS, enableLivePreview = false) {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_findOneBusinessEntryWhere : _findOneBusinessEntryWhere;
  return fn(
    contentType,
    key,
    value,
    locale,
    fieldExceptions,
    enableLivePreview
  );
};
const _findOneBusinessEntry = async function _findOnBusinessEntry(contentType, entryId, locale, fieldExceptions, enableLivePreview) {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    const result = await stackClient.stack.ContentType(contentType).Entry(entryId).except(fieldExceptions).addQuery("include_dimension", "true").language(locale).toJSON().fetch();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully using findOneBusinessEntry with
          contentType: ${contentType},
          entryId: ${entryId},
          locale: ${locale}
          fieldExceptions: ${fieldExceptions},
          enableLivePreview: ${enableLivePreview},
          resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack findOneBusinessEntry with
          contentType: ${contentType},
          entryId: ${entryId},
          locale: ${locale}
          fieldExceptions: ${fieldExceptions},
          enableLivePreview: ${enableLivePreview},
          resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
  }
  return null;
};
const cached_findOneBusinessEntry = unstable_cache(
  _findOneBusinessEntry,
  ["digital_findOneBusinessEntry"],
  { revalidate: 1800 }
);
const findOneBusinessEntry = async function findOneBusinessEntry2(contentType, entryId, locale, fieldExceptions = DEFAULT_FIELD_EXCEPTIONS, enableLivePreview = false) {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_findOneBusinessEntry : _findOneBusinessEntry;
  return fn(contentType, entryId, locale, fieldExceptions, enableLivePreview);
};
const _getConfigurationSettingByDeveloperKey = async (contentType, developmentKey, locale, fieldExceptions, enableLivePreview) => {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    const result = await stackClient.stack.ContentType(contentType).Query().where("development_key", developmentKey).language(locale).except(fieldExceptions).toJSON().findOne();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully at getConfigurationSettingByDeveloperKey with
          contentType: ${contentType},
          developmentKey: ${developmentKey},
          locale: ${locale},
          fieldExceptions: ${fieldExceptions},
          enableLivePreview: ${enableLivePreview}
          resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack getConfigurationSettingByDeveloperKey with
          contentType: ${contentType},
          developmentKey: ${developmentKey},
          locale: ${locale},
          fieldExceptions: ${fieldExceptions},
          enableLivePreview: ${enableLivePreview}
          resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_getConfigurationSettingByDeveloperKey = unstable_cache(
  _getConfigurationSettingByDeveloperKey,
  ["digital_getConfigurationSettingByDeveloperKey"],
  { revalidate: 1800 }
);
const getConfigurationSettingByDeveloperKey = async (contentType, developmentKey, locale, fieldExceptions = DEFAULT_FIELD_EXCEPTIONS, enableLivePreview = false) => {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_getConfigurationSettingByDeveloperKey : _getConfigurationSettingByDeveloperKey;
  return fn(
    contentType,
    developmentKey,
    locale,
    fieldExceptions,
    enableLivePreview
  );
};
const _getConfigurationSettingByConfigKey = async (contentType, configKey, locale, fieldExceptions, enableLivePreview) => {
  let stackClient = ContentStack;
  stackClient.setCachePolicy(CachePolicy.CACHE_THEN_NETWORK);
  if (enableLivePreview) {
    stackClient = ContentStackLivePreview;
    stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
  }
  try {
    const result = await stackClient.stack.ContentType(contentType).Query().where("configkey", configKey).language(locale).except(fieldExceptions).toJSON().findOne();
    if (process.env.LOG_CONTENTSTACK_CALLS === "true") {
      console.log(
        `Business stack data fetched successfully at getConfigurationSettingByConfigKey with
          contentType: ${contentType},
          configKey: ${configKey},
          locale: ${locale},
          fieldExceptions: ${fieldExceptions},
          enableLivePreview: ${enableLivePreview}
          resulting in data: ${typeof result === "object" && JSON.stringify(result)}`
      );
    }
    return result;
  } catch (err) {
    const errorString = `An error occurred in Business stack getConfigurationSettingByConfigKey with
          contentType: ${contentType},
          configKey: ${configKey},
          locale: ${locale},
          fieldExceptions: ${fieldExceptions},
          enableLivePreview: ${enableLivePreview}
          resulting in error: ${typeof err === "object" && JSON.stringify(err)}`;
    console.error(errorString);
    throw new Error(errorString);
  }
};
const cached_getConfigurationSettingByConfigKey = unstable_cache(
  _getConfigurationSettingByConfigKey,
  ["digital_getConfigurationSettingByConfigKey"],
  { revalidate: 1800 }
);
const getConfigurationSettingByConfigKey = async (contentType, configKey, locale, fieldExceptions = DEFAULT_FIELD_EXCEPTIONS, enableLivePreview = false) => {
  const fn = typeof window === "undefined" && !enableLivePreview ? cached_getConfigurationSettingByConfigKey : _getConfigurationSettingByConfigKey;
  return fn(
    contentType,
    configKey,
    locale,
    fieldExceptions,
    enableLivePreview
  );
};
export {
  DEFAULT_FIELD_EXCEPTIONS,
  _findCountOfAllEntriesByContentType,
  _findPaginateEntriesByContentType,
  findAllBusinessEntriesByContentType,
  findCountOfAllEntriesByContentType,
  findOneBusinessEntry,
  findOneBusinessEntryByContentType,
  findOneBusinessEntryWhere,
  findPaginateEntriesByContentType,
  getConfigurationSettingByConfigKey,
  getConfigurationSettingByDeveloperKey
};
